import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CheckSsoEnabledService {

  constructor(private httpClient: HttpClient, private rootScopeService: RootScopeService, 
              private httpHeaderService: HttpHeadersService) { 

  }

  public checkSSOEnabled(token:string): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.get(environment.servicePath + '/lfuser/is_SSO_enabled_by_token_key?tokenKey='+token, { headers});
   }

   public linkSSOUser(): Observable<any> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    return this.httpClient.post(environment.servicePath + '/sso/sso_user', {}, {headers});
   }
}
